export class Timezone {
  id: number;

  zoneName: string;

  countryCode: string;

  static parse(data: any): Timezone {
    return Object.assign(new Timezone(), {
      id: data.id,
      zoneName: data.zoneName,
      countryCode: data.countryCode
    });
  }
}
